// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__27pW9","balanceDisclaimer":"posDashboard_balanceDisclaimer__3xzje"};